import React, { Component } from "react";
import "./About.css";
import { Fade } from "react-reveal";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";
import TimelineSection from "../../components/timeline/TimelineSection";

const AboutSectionContent = ({ theme }) => {
  const { language } = useLanguage();

  return (
    <div className="about-main-div">
      <div className="about-text-div">
        {/* Timeline Component for Church History */}
        <TimelineSection theme={theme} />
      </div>
    </div>
  );
};

class AboutSection extends Component {
  render() {
    const theme = this.props.theme;
    return <AboutSectionContent theme={theme} />;
  }
}

export default AboutSection;
